import { render, staticRenderFns } from "./ConfigurationForm.vue?vue&type=template&id=34c20f2c&"
import script from "./ConfigurationForm.vue?vue&type=script&lang=js&"
export * from "./ConfigurationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports